import React from 'react'
import PropTypes from 'prop-types'

import ListItemCell from "./cell"
import DNDComponent from "core/gd-modules/dnd/dnd-component"
import GlistActionsCell from "../actions/cell"
import FirstColumn from "./first-column"
import LastColumn from "./last-column"
import {DND_HANDLE_COLUMN_WIDTH} from "../../manager/columns-manager/columns"

const debug = false
// const debug = "ListItem"

export default class ListItem extends DNDComponent {

    static propTypes = {
        module: PropTypes.object,
        data: PropTypes.object,
    }

    static defaultProps = _.assign({}, DNDComponent.defaultProps, {
        dragTriggerDelta: 5,
    });

    // for immediate rerender on action in actions cell if required
    _reRender = () => {
        this.forceUpdate();
    }

    onClick(e) {
        // if (this.props.module.canEditItems && !gd.utils.Dom.findNodeByClassName(e.target, ['is-title-field'])) return;

        if (gd.utils.Dom.checkNodeHasFunction(e.target, ['onclick'], this.componentEl)) {
            debug && console.log(debug, "onClick -> IGNORE - target has own onClick function ")
            return; //do nothing if target has own onClick function
        }
        debug && console.log(debug,"onClick() itemId=", this.props.data.id, "item=",this.props.data)
        this.props.module.onItemClick(this.props.data.id, this.props.data);
    }

    canDrag(e) {
        const canDrag = super.canDrag(e)
        return canDrag && !this.props.module.sortBy.value
    }

    onDragStart() {
        this.props.module.setDragInProgress(true);

        return super.onDragStart();
    }

    onDraggingOver(draggedItem, mouseEvent) {
        super.onDraggingOver(draggedItem, mouseEvent);
        if (draggedItem.getDNDId() === this.getDNDId()) return; // do nothing for same item

        const area = gd.utils.Dom.checkMouseOverRectArea(mouseEvent, this.componentEl.getBoundingClientRect());
        const type = area.yLine === 1 ? 'above' : 'below';

        this.props.module.data.onReorderItem(mouseEvent, draggedItem.props.data, this.props.data, type);
    }

    onDragEnd(mouseEvent, dx, dy, dropResult) {
        this.props.module.setDragInProgress(false);

        super.onDragEnd(mouseEvent, dx, dy, dropResult);
        if(this.props.module.data.onConfirmReorder) this.props.module.data.onConfirmReorder(this.props.data)
    }

    render() {
        const columns = this.props.module.columns.allVisible();
        const columnsNum = columns.length;

        const classes = Classes("glist-row", this.props.className, {
            'is-dragged'    : this.props.dndManager && this.props.dndManager.isDraggedItem(this.getDNDId()),
            'with-group-by' : !!this.props.module.groupBy,
            'is-selected'   : this.props.module.selection.isSelected(this.props.data.id)
        });

        const shellStyles = {
            minWidth: 'calc(100% - {0}px)'.f(this.props.module.skin.paddingLeft + this.props.module.skin.paddingRight + (this.props.module.canDndItems ? DND_HANDLE_COLUMN_WIDTH : 0))
        }

        debug && console.log(debug, 'render', shellStyles)

        return (
            <div className={classes}>
                <FirstColumn module={this.props.module}/>

                {this.props.module.canDndItems &&
                    <div className="dnd-handle-column ui5-icon-dnd"/>
                }

                <div className="shell" style={shellStyles}>

                    {_.map(columns, (column,key)=>{
                        let CellComponent = this.props.module.renderCellComponent

                        if (!CellComponent) {
                            switch (column.type) {
                                case 'actions':
                                    CellComponent = GlistActionsCell;
                                    break

                                default:
                                    CellComponent = ListItemCell;
                            }
                        }

                        return <CellComponent key={'{0}_{1}'.f(column.fieldId, key)}
                                              module={this.props.module}
                                              data={this.props.data}
                                              column={column}
                                              isFirst={key === 0}
                                              isLast={key === columnsNum - 1}
                                              reRender={this._reRender}/>
                    })}

                    {this.props.module.canAddColumns &&
                        <div className="add-column"/>
                    }

                </div>

                {this.props.module.groupBy &&
                    <LastColumn module={this.props.module}/>
                }
            </div>
        );
    }
}
